import { AnyAction } from "redux";
import {
  CLEAR_ACTIVE_KPI_CLIENT_ID,
  SET_ACTIVE_KPI_CLIENT_ID
} from "../actions/activeKpiClient";

export const activeKpiClient = (state = 0, action: AnyAction) => {
  switch (action.type) {
    case SET_ACTIVE_KPI_CLIENT_ID:
      return action.id as number;
    case CLEAR_ACTIVE_KPI_CLIENT_ID:
      return 0;
    default:
      return state;
  }
};

export default activeKpiClient;
